import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectSiteUrl } from 'core/selectors/app';

function LinksTray({ isExpanded, config }) {
  const siteUrl = useSelector(selectSiteUrl);
  const { extraRewardsLanguage } = config;
  const [shouldUsePositionTriggerClassName, setShouldUsePositionTriggerClassName] = useState(true);

  // Trigger section fixed position recalculation since it is not calculated properly on initial page load on iPhone
  // CLPL-15683 #2 (https://tickets.cartera.com/secure/attachment/270011/16-17.mp4)
  useEffect(() => {
    setTimeout(() => setShouldUsePositionTriggerClassName(false), 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const collapsedClassName = !isExpanded ? 'mn_collapsed' : '';
  const positionTriggerClassName = shouldUsePositionTriggerClassName ? 'mn_positionTrigger' : '';

  return (
    <div
      className={`mn_quickLinksTrayContent ${collapsedClassName} ${positionTriggerClassName}`}
      aria-hidden={!isExpanded}
    >
      <nav className="mn_quickLinksTrayNav">
        <a
          className="mn_myAccountLink"
          href={`${siteUrl}/ai____.htm`}
          data-name="Account"
          title="Opens account page"
          tabIndex={`${isExpanded ? 0 : -1}`}
        >My account
        </a>
        <a
          className="mn_extraRewardsLink"
          href={`${siteUrl}/p/extra-rewards.htm`}
          data-name="Extra rewards"
          title="Opens Extra Rewards page"
          tabIndex={`${isExpanded ? 0 : -1}`}
        >{extraRewardsLanguage}
        </a>
        <a
          className="mn_allStoresLink"
          href={`${siteUrl}/b____.htm`}
          data-name="All stores"
          title="Opens All Stores page"
          tabIndex={`${isExpanded ? 0 : -1}`}
        >All stores
        </a>
      </nav>
    </div>
  );
}

export default LinksTray;
